import React from 'react'

function ThankYou() {
  return (
    <div>
<div>
  <header className="site-header" id="header">
    <h1 className="site-header__title" data-lead-id="site-header-title">THANK YOU!</h1>
  </header>
  <div className="main-content">
    <i className="fa fa-check main-content__checkmark" id="checkmark" />
    <p className="main-content__body" data-lead-id="main-content-body">Form submitted successfully!<br />
      Thank you! We will reply to you soon!</p>
    <p><a href="/thankyou">Go Back</a></p>
  </div>
</div>


	

    </div>
  )
}

export default ThankYou
